import ApprovalWorkFlow from '@/api/approval-work-flow'
import Position from '@/api/position'
import Employee from '@/api/employee'
import ProgramMain from '@/api/main-program'
import ProgramSub from '@/api/sub-program'
import Level from '@/api/level'
import Grade from '@/api/grade'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  approvalTypes: [],
  approverTypes: [],
  approvalActivities: [],
  employees: [],
  positions: [],
  parameters: [],
  conditionTypes: [],
  approvalOperators: [],
  mainPrograms: [],
  subPrograms: [],
  levels: [],
  grades: [],
  edit_data: {}
}

export const getters = {
  operatorsByConditionTypes: state => ({ cond_type_id } = {}) => {
    if (
      !state.conditionTypes.filter(ct => ct.cond_type_id == cond_type_id)
        .length > 0
    ) {
      return state.approvalOperators.filter(o => o.num_of_value == 1)
    }
    if (
      !state.conditionTypes.filter(ct => ct.cond_type_id == cond_type_id)[0]
        .allow_between
    ) {
      return state.approvalOperators.filter(o => o.num_of_value == 1)
    }

    return state.approvalOperators
  },
  valueOptions: state => ({ cond_type_id } = {}) => {
    if (cond_type_id == 1) {
      return state.mainPrograms.map(el => ({
        id: el.acp_id,
        label: el.acp_name_foreign
      }))
    }
    if (cond_type_id == 2) {
      return state.subPrograms.map(el => ({
        id: el.acps_id,
        label: el.acps_name_foreign
      }))
    }
    if (cond_type_id == 3) {
      return state.levels.map(el => ({
        id: el.level_id,
        label: el.level_name_foreign
      }))
    }
    if (cond_type_id == 4) {
      return state.grades.map(el => ({
        id: el.grade_id,
        label: el.grade_name_foreign
      }))
    }
  }
}

export const mutations = {
  ...baseMutations,
  RECIEVED_APPROVAL_TYPES(state, data) {
    state.approvalTypes = data
  },
  RECIEVED_PARAMETERS(state, data) {
    state.parameters = data
  },
  RECIEVED_APPROVER_TYPES(state, data) {
    state.approverTypes = data
  },
  RECIEVED_APPROVAL_ACTIVITIES(state, data) {
    state.approvalActivities = data
  },
  RECIEVED_EMPLOYEES(state, data) {
    state.employees = data
  },
  RECIEVED_POSITIONS(state, data) {
    state.positions = data
  },
  RECIEVED_APPROVAL_CONDITION_TYPES(state, data) {
    state.conditionTypes = data
  },
  RECIEVED_APPROVAL_OPERATORS(state, data) {
    state.approvalOperators = data
  },
  RECIEVED_MAIN_PROGRAMS(state, data) {
    state.mainPrograms = data
  },
  RECIEVED_SUB_PROGRAMS(state, data) {
    state.subPrograms = data
  },
  RECIEVED_LEVELS(state, data) {
    state.levels = data
  },
  RECIEVED_GRADES(state, data) {
    state.grades = data
  },
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return ApprovalWorkFlow.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return ApprovalWorkFlow.store(data)
  },
  storeCondition(context, data) {
    return ApprovalWorkFlow.storeCondition(data)
  },
  update(context, { app_flow_id, ...data }) {
    return ApprovalWorkFlow.update(
      app_flow_id,
      Object.assign({}, data, {
        total_hours: parseFloat(data.total_hours)
      })
    )
  },
  destroy(context, id) {
    return ApprovalWorkFlow.destroy(id)
  },
  deleteCondition(context, id) {
    return ApprovalWorkFlow.destroyCondition(id)
  },

  fetchPosition(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        setup_positions: 'position_id,pos_name_en,pos_name_kh'
      },
      ...attributes
    }

    return Position.get({ params }).then(response => {
      context.commit('RECIEVED_POSITIONS', response.data)
      return Promise.resolve(response)
    })
  },

  fetchEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        setup_staff_information: 'staff_id,name_en,name_kh'
      },
      filter: { in_registered_to_user_login: true },
      ...attributes
    }

    return Employee.get({ params }).then(response => {
      context.commit('RECIEVED_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchProgramMain(context, attributes = {}) {
    return ProgramMain.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_mains: 'acp_id,acp_name_native,acp_name_foreign'
        },
        ...attributes
      }
    }).then(response => {
      context.commit('RECIEVED_MAIN_PROGRAMS', response.data)
      return Promise.resolve(response)
    })
  },
  fetchProgramSub(context, attributes = {}) {
    return ProgramSub.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_subs: 'acps_id,acps_name_native,acps_name_foreign'
        },
        ...attributes
      }
    }).then(response => {
      context.commit('RECIEVED_SUB_PROGRAMS', response.data)
      return Promise.resolve(response)
    })
  },
  fetchLevel(context, attributes = {}) {
    return Level.get({
      params: {
        fields: {
          academic_program_levels: 'level_id,level_name_foreign'
        },
        page: -1
      },
      ...attributes,
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    }).then(response => {
      context.commit('RECIEVED_LEVELS', response.data)
      return Promise.resolve(response)
    })
  },
  fetchGrade(context, attributes = {}) {
    return Grade.get({
      params: {
        fields: {
          academic_program_level_grades: 'grade_id,grade_name_foreign'
        },
        page: -1
      },
      ...attributes,
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    }).then(response => {
      context.commit('RECIEVED_GRADES', response.data)
      return Promise.resolve(response)
    })
  },

  async fetchResource(context) {
    if (!context.state.approvalTypes.length > 0) {
      let response = await ApprovalWorkFlow.getApprovalType()
      context.commit('RECIEVED_APPROVAL_TYPES', response.data)
    }
    if (!context.state.approverTypes.length > 0) {
      let response = await ApprovalWorkFlow.getApproverType()
      context.commit('RECIEVED_APPROVER_TYPES', response.data)
    }
    if (!context.state.approvalActivities.length > 0) {
      let response = await ApprovalWorkFlow.getApprovalActivity()
      context.commit('RECIEVED_APPROVAL_ACTIVITIES', response.data)
    }
    if (!context.state.conditionTypes.length > 0) {
      let response = await ApprovalWorkFlow.getConditionType()
      context.commit('RECIEVED_APPROVAL_CONDITION_TYPES', response.data)
    }
    if (!context.state.approvalOperators.length > 0) {
      let response = await ApprovalWorkFlow.getApprovalOperator()
      context.commit('RECIEVED_APPROVAL_OPERATORS', response.data)
    }
  },

  async fetchParameter(context, app_type_id) {
    let response = await ApprovalWorkFlow.getParameters({
      params: { app_type_id: app_type_id }
    })
    context.commit('RECIEVED_PARAMETERS', response.data)
    return response
  }
}
